import { useDispatch } from 'react-redux';
import { Eye, EyeClosed } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';

import ReactLoading from 'react-loading';
import { useForm } from 'react-hook-form';

import {
  loadingToggleAction,
  loginAction,
} from '../../store/actions/AuthActions';
import { handleToast } from '../../components/Toast';
import { FormRecoveryPassword } from '../components/FormRecoveryPassword';
import {
  AsideContent,
  ButtonRecoveryPassword,
  ContainerLogin,
  ContentForm,
  ContentInput,
  ContentLogin,
  MobileContent,
} from './LoginStyles';

import asideImg from '../../assets/loginAside.svg';
import logoImg from '../../assets/logo/azul-svg.svg';
import logoAndroid from '../../assets/google-play.png';
import logoIOS from '../../assets/app-store.png';
import { ButtonStyle } from '../../components/ButtonStyle';

export default function Login(props) {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const linkAndroid =
      'https://play.google.com/store/apps/details?id=io.ionic.iBox6';
    const linkIOS =
      'itms-apps://apps.apple.com/br/app/ibox6-investimentos/id6738101223'; // Ajustado o esquema
    // https://apps.apple.com/br/app/ibox6-investimentos/id6738101223
    if (/android/i.test(userAgent)) {
      console.log('Redirecionando para a Play Store...');
      window.location.href = linkAndroid;
      return;
    }

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      console.log('Redirecionando para a App Store...');
      window.location.href = linkIOS;
      return;
    }

    // console.log('Nenhum dispositivo compatível detectado.');
  });

  const dispatch = useDispatch();
  const { register, handleSubmit, setValue, watch } = useForm();
  const [viewPassword, setViewPassword] = useState(false);
  const [modalRecoveryPassword, setModalRecoveryPassword] = useState({
    open: false,
    success: false,
  });
  const [loading, setLoading] = useState(false);

  const paramsTraffic = window.location.search
    .substr(1)
    .split('&')
    .reduce((queryParams, param) => {
      const [key, value] = param.split('=');
      queryParams[key] = value;
      return queryParams;
    }, {});

  const handleFocus = (event) => {
    const input = event.target;
    const label = input.previousElementSibling;
    const placeholder = input.nextElementSibling;

    label.classList.add('active');
    placeholder.classList.add('visible');
  };

  const handleBlur = (event) => {
    const input = event.target;
    const label = input.previousElementSibling;
    const placeholder = input.nextElementSibling;

    if (!input.value) {
      label.classList.remove('active');
      placeholder.classList.remove('visible');
    }
  };
  useEffect(() => {
    if (paramsTraffic.existing_code) {
      dispatch(loadingToggleAction(true));
      dispatch(
        loginAction({
          token: paramsTraffic.existing_code,
          history: props.history,
          setLoading,
          email: '',
          password: '',
          register: false,
          registerBusiness: true,
        })
      );
    } else if (paramsTraffic.email) {
      setValue('email', paramsTraffic.email);
      setValue('password', '@ibox2022');
      dispatch(loadingToggleAction(true));
      dispatch(
        loginAction(
          paramsTraffic.email,
          '@ibox2022',
          props.history,
          false,
          setLoading
        )
      );
    }
  }, [paramsTraffic]);

  const email = watch('email');

  async function onLogin(data) {
    setLoading(true);
    if (!data.email) {
      setLoading(false);

      return handleToast(true, 'Email obrigatório');
    }
    data.email = data.email.toLowerCase();
    if (!data.password) {
      setLoading(false);

      return handleToast(true, 'Senha obrigatório');
    }

    dispatch(loadingToggleAction(true));
    dispatch(
      loginAction({
        email: data.email,
        password: data.password,
        history: props.history,
        register: false,
        setLoading,
        redirectPath: '/dashboard',
      })
    );
  }

  return (
    <ContainerLogin>
      <AsideContent>
        <img src={asideImg} />
      </AsideContent>

      <ContentLogin>
        <img src={logoImg} alt="logo" />
        <h2>
          {modalRecoveryPassword.success
            ? 'Confira seu e-mail'
            : modalRecoveryPassword.open
            ? 'Reiniciar Senha'
            : 'Acesse sua conta'}
        </h2>
        {modalRecoveryPassword.open ? (
          <FormRecoveryPassword
            email={email}
            setModalRecoveryPassword={setModalRecoveryPassword}
          />
        ) : (
          <ContentForm onSubmit={handleSubmit(onLogin)}>
            <ContentInput>
              <label htmlFor="email">E-mail *</label>
              <input
                type="text"
                id="email"
                placeholder="Insira seu e-mail"
                {...register('email')}
                onFocus={handleFocus}
                onBlur={handleBlur}
              />
              <span></span>
            </ContentInput>
            <ContentInput>
              <div>
                <label htmlFor="password">Senha *</label>
                <input
                  className="inputSenha"
                  type={viewPassword ? 'text' : 'password'}
                  id="password"
                  {...register('password')}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  placeholder="Insira sua senha" // Adicione um espaço para que o placeholder padrão não apareça
                />
                <span></span>
                <i className="verSenha">
                  {viewPassword ? (
                    <Eye
                      onClick={() => setViewPassword(!viewPassword)}
                      size={24}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <EyeClosed
                      onClick={() => setViewPassword(!viewPassword)}
                      size={24}
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                </i>
              </div>
            </ContentInput>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <ButtonRecoveryPassword
                onClick={() =>
                  setModalRecoveryPassword({
                    ...modalRecoveryPassword,
                    open: true,
                  })
                }
                type="button"
              >
                Esqueceu a senha?
              </ButtonRecoveryPassword>
            </div>

            {loading ? (
              <ButtonStyle
                disabled={loading}
                background="#EC6643"
                color="#fff"
                type="submit"
              >
                <ReactLoading
                  type="balls"
                  color="#FFF"
                  width="2rem"
                  height="2rem"
                />
              </ButtonStyle>
            ) : (
              <ButtonStyle
                disabled={loading}
                background="#EC6643"
                color="#fff"
                type="submit"
              >
                ENTRAR
              </ButtonStyle>
            )}
          </ContentForm>
        )}
        {!modalRecoveryPassword.open && (
          <span className="registerText">
            Ainda não tem uma conta?{' '}
            <a
              // href="https://ibox6.com.br/?utm_source=iboxapp&utm_medium=btncadastro&utm_campaign=ibox-cadastro"
              href="https://ibox6.com.br/lp-b/?utm_campaign=direto-neutro-org&versao=lp-b#form"
              target="_blank"
            >
              Cadastrar
            </a>
          </span>
        )}
      </ContentLogin>
      <MobileContent>
        <div>
          <h4>
            <strong>Baixe o App do iBox6.</strong>
          </h4>
          <p>
            Aproveite todas as funcionalidades disponíveis agora direto no seu
            celular.
          </p>
          <div className="images">
            <img
              src={logoAndroid}
              onClick={() =>
                (window.location.href =
                  'https://play.google.com/store/apps/details?id=io.ionic.iBox6')
              }
              width={'200px'}
              alt="Logo Android"
            />
            <img
              src={logoIOS}
              onClick={() =>
                (window.location.href =
                  'itms-apps://apps.apple.com/br/app/ibox6-investimentos/id6738101223')
              }
              width={'200px'}
              alt="Logo iOS"
            />
          </div>
        </div>
      </MobileContent>
      {/* <ModalDesigner
        id="recoverPassword"
        isOpen={modalRecoveryPassword}
        setState={setModalRecoveryPassword}
        title="Login a partir de e-mail ou número de telefone"
        size="sm"
      >
        <FormRecoveryPassword email={email} />
      </ModalDesigner> */}
    </ContainerLogin>
  );
}
